import './account_email';
import './account_name';
import './account_loginid';
import './account_type';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/account_details/index.js